import React from 'react';
import PropTypes from 'prop-types';
import {OverlaySlider} from '../OverlaySlider';
import './style.scss';

export function SliderGroup(props) {
  const onChangeHighlight = (params) => {
    props.changeHighlight({
      ...params,
      groupID: props.id,
      componentID: props.componentID,
    });
  };

  const renderSliders = () => {
    return props.sliders.map((slider, key) => (
      <GroupItem key={key} {...slider} onChange={onChangeHighlight} />
    ));
  };
  return (
    <div className='slider-group'>
      <span className='slider-group__label'>{props.label}</span>
      <div className='slider-group__item'>{renderSliders()}</div>
    </div>
  );
}

SliderGroup.propTypes = {
  id: PropTypes.number,
  label: PropTypes.number,
  sliders: PropTypes.array,
  componentID: PropTypes.number,
  changeHighlight: PropTypes.func,
};

function GroupItem(props) {
  const getHighlight = () => {
    let start = props.current.start;
    let size = props.current.text.length;
    return [start, size];
  };

  const sliderOnChange = (current) => {
    props.onChange({current, sliderID: props.id});
  };

  return (
    <OverlaySlider
      sequence={props.sequence}
      highlight={getHighlight()}
      highlightClass={props.highlightClass}
      onChange={sliderOnChange}
      disable={props.disable}
      label={props.label}
    />
  );
}

GroupItem.propTypes = {
  sequence: PropTypes.string,
  highlightClass: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  disable: PropTypes.bool,
  current: PropTypes.object,
};
